import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from 'vuex-module-decorators'
import store from '@/store'

export enum DeviceType {
  Mobile,
  Desktop
}

export interface IAsrRtState {
  needAlert: boolean // 当前是否需要弹窗提示，如果正在合成等情况，离开页面时需要弹窗提示用户
  alertDialogVisible: boolean // 弹窗显示状态
  saveCb: Array<(...args: any) => any> // 保存窗口保存后回调
  cancelSaveCb: Array<(...args: any) => any> // 保存窗口取消保存后回调
  cancelCb: Array<(...args: any) => any> // 保存窗口取消后回调
}

@Module({ dynamic: true, store, name: 'asr-rt' })
class AsrRt extends VuexModule implements IAsrRtState {
  public needAlert = false
  public alertDialogVisible = false

  public saveCb: Array<(...args: any) => any> = []
  public cancelSaveCb: Array<(...args: any) => any> = []
  public cancelCb: Array<(...args: any) => any> = []

  @Mutation
  private TOGGLE_NEED_ALERT(needAlert: boolean) {
    this.needAlert = needAlert
  }
  @Mutation
  private TOGGLE_ALERT_DIALOG_VISIBLE(alertDialogVisible: boolean) {
    this.alertDialogVisible = alertDialogVisible
  }
  @Mutation
  private PUSH_SAVE_CB(saveCb: (...args: any) => any) {
    this.saveCb.push(saveCb)
  }
  @Mutation
  private PUSH_CANCEL_SAVE_CB(cancelSaveCb: (...args: any) => any) {
    this.cancelSaveCb.push(cancelSaveCb)
  }
  @Mutation
  private PUSH_CANCEL_CB(cancelCb: (...args: any) => any) {
    this.cancelCb.push(cancelCb)
  }

  @Mutation
  private CLEAR_CB() {
    this.saveCb.length = 0
    this.cancelCb.length = 0
    this.cancelSaveCb.length = 0
  }

  @Action
  public ToggleNeedAlert(needAlert: boolean) {
    this.TOGGLE_NEED_ALERT(needAlert)
  }
  @Action
  public ToggleAlertDialogVisible(alertDialogVisible: boolean) {
    this.TOGGLE_ALERT_DIALOG_VISIBLE(alertDialogVisible)
  }
  @Action
  public PushSaveCb(saveCb: (...args: any) => any) {
    this.PUSH_SAVE_CB(saveCb)
  }
  @Action
  public PushCancelSaveCb(cancelSaveCb: (...args: any) => any) {
    this.PUSH_CANCEL_SAVE_CB(cancelSaveCb)
  }
  @Action
  public PushCancelCb(cancelCb: (...args: any) => any) {
    this.PUSH_CANCEL_CB(cancelCb)
  }
  @Action
  public ClearCb() {
    this.CLEAR_CB()
  }
}

export const AsrRtModule = getModule(AsrRt)
